<!--begin::Container-->
<div [ngClass]="headerContainerCSSClasses" class="d-flex flex-column align-items-stretch justify-content-between">
	<ng-container *ngIf="loader$ | async as _loader">
		<ngb-progressbar class="loading-bar" height="3px" [value]="_loader"></ngb-progressbar>
	</ng-container>

	<!-- ROW 1: Logo & Topbar (Indicators, Company Selector, User) -->
	<div class="d-flex align-items-center justify-content-between w-100 p-0 p-lg-2 border-bottom-0 pb-0">
		<ng-container *ngIf="!asideSelfDisplay">
			<!--begin::Header Logo-->
			<div class="header-logo mr-3 d-none d-lg-block">
				<a routerLink="/" class="brand-logo pt-1" (click)="goToMain()">
					<img *ngIf="!esFontSizeExtraLarge()" alt="Logo" style="padding: 11px" [attr.src]="headerLogo" class="img-fluid logo-full" />

					<!-- Mostrar el ícono SOLO si está en extra-large -->
					<i *ngIf="esFontSizeExtraLarge()" class="fas fa-sync-alt fa-2x" style="color: #007bff" title="Recargar"></i>
				</a>
			</div>
			<!--end::Header Logo-->
			<!-- Divisas Widget relocated here -->
			<div class="mr-auto ml-2 d-none d-lg-block">
				<app-divisas-widget [hideEuro]="hideEuro"></app-divisas-widget>
			</div>
		</ng-container>

		<app-topbar (hideEuroChange)="onHideEuroChange($event)" class="topbar w-100 justify-content-end"></app-topbar>
	</div>

	<!-- ROW 2: Navigation Menu -->
	<ng-container *ngIf="headerMenuSelfDisplay">
		<!--begin::Header Menu Wrapper-->
		<div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
			<!--begin::Header Menu-->
			<!-- Don't change id => 'kt_header_menu' -->
			<ng-container *ngIf="headerMenuSelfStatic">
				<!-- STATIC MENU -->
				<app-header-menu #ktHeaderMenu id="kt_header_menu" class="header-menu header-menu-mobile" [ngClass]="headerMenuCSSClasses"></app-header-menu>
			</ng-container>
			<ng-container *ngIf="!headerMenuSelfStatic">
				<!-- DYNAMIC MENU -->
				<app-header-menu-dynamic #ktHeaderMenu id="kt_header_menu" class="header-menu header-menu-mobile mt-3" [ngClass]="headerMenuCSSClasses"></app-header-menu-dynamic>
			</ng-container>
			<!--end::Header Menu-->
		</div>
		<!--end::Header Menu Wrapper-->
	</ng-container>

	<ng-container *ngIf="!headerMenuSelfDisplay">
		<div></div>
	</ng-container>
</div>
<!--end::Container-->
<swal #timeoutSwal title="Operación" text="Operación realizada" icon="warning" [showConfirmButton]="true" [showCancelButton]="true" confirmButtonText="Mantener sesión" cancelButtonText="Cerrar sesión" confirmButtonColor="#3699FF" cancelButtonColor="#f4516c"></swal>
